import { alpha, useTheme } from '@mui/material';
import { Color } from '../../types';

type Args = {
  color: Color;
};

export const useStyles = (args: Args) => {
  const theme = useTheme();
  const { color } = args;
  const colorBox = {
    height: '56px',
    width: '56px',
    borderRadius: '100px',
    padding: '12px',
    backgroundColor: `${color}.lighter`,
    cursor: 'pointer',
  };

  return {
    colorBox,
    activeColorBox: {
      ...colorBox,
      border: `3px solid ${alpha(theme.palette[color].main, 0.32)}`,
      padding: '9px',
    },
    icon: {
      width: '32px',
      height: '32px',
      color: theme.palette[color].main,
    },
  };
};
